import { Photo } from "@medusajs/icons"
import { clx } from "@medusajs/ui"
import { getImageUrl } from "../../../lib/image-utils"

type ThumbnailProps = {
  src?: string | null
  alt?: string
  size?: "small" | "base"
}

export const Thumbnail = ({ src, alt, size = "base" }: ThumbnailProps) => {
  const imageUrl = getImageUrl(src)
  
  return (
    <div
      className={clx(
        "bg-ui-bg-component border-ui-border-base flex items-center justify-center overflow-hidden rounded border",
        {
          "h-8 w-6": size === "base",
          "h-5 w-4": size === "small",
        }
      )}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={alt || "Product image"}
          className="h-full w-full object-cover object-center"
          onError={(e) => {
            // Fallback to placeholder on error
            const target = e.target as HTMLImageElement
            target.style.display = 'none'
            const parent = target.parentElement
            if (parent) {
              const icon = parent.querySelector('.fallback-icon')
              if (!icon) {
                const fallbackIcon = document.createElement('div')
                fallbackIcon.className = 'fallback-icon text-ui-fg-subtle'
                fallbackIcon.innerHTML = '<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd"></path></svg>'
                parent.appendChild(fallbackIcon)
              }
            }
          }}
        />
      ) : (
        <Photo className="text-ui-fg-subtle" />
      )}
    </div>
  )
}
